import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BillingOneTimePayUiModule } from '@amfam/billing/one-time-pay/ui';
import { BillingPaymentMethodFeatureModule } from '@amfam/billing/payment-method/feature';
import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { ChoosePaymentAmountModalComponent } from './components/choose-payment-amount-modal/choose-payment-amount-modal.component';
import { PaymentReviewWrapperHSPhoenixComponent } from './components/payment-review-wrapper-hs-phoenix/payment-review-wrapper-hs-phoenix.component';
import { PhoenixPaymentTimeoutModalComponent } from './components/phoenix-payment-timeout-modal/phoenix-payment-timeout-modal.component';
import { ChooseAccountWrapperComponent } from './containers/choose-account-wrapper/choose-account-wrapper.component';
import { HSChooseAccountWrapperComponent } from './containers/hs-choose-account-wrapper/hs-choose-account-wrapper.component';
import { PaymentConfirmationWrapperComponent } from './containers/payment-confirmation-wrapper/payment-confirmation-wrapper.component';
import { PaymentReviewWrapperComponent } from './containers/payment-review-wrapper/payment-review-wrapper.component';
import { PhoenixChooseAccountWrapperComponent } from './containers/phoenix-choose-account-wrapper/phoenix-choose-account-wrapper.component';
import { PhoenixPaymentConfirmationWrapperComponent } from './containers/phoenix-payment-confirmation-wrapper/phoenix-payment-confirmation-wrapper.component';
import { ReviewPaymentWrapperComponent } from './containers/review-payment-wrapper/review-payment-wrapper.component';
import { SimplifiedPaymentChooseAccountWrapperComponent } from './containers/simplified-payment-choose-account-wrapper/simplified-payment-choose-account-wrapper.component';
import { SimplifiedPaymentConfirmationWrapperComponent } from './containers/simplified-payment-confirmation-wrapper/simplified-payment-confirmation-wrapper.component';
import { OneTimePayRoutingModule } from './routing/one-time-pay-routing.module';

@NgModule({
  declarations: [
    ChooseAccountWrapperComponent,
    ReviewPaymentWrapperComponent,
    PaymentConfirmationWrapperComponent,
    ChoosePaymentAmountModalComponent,
    SimplifiedPaymentChooseAccountWrapperComponent,
    HSChooseAccountWrapperComponent,
    PhoenixChooseAccountWrapperComponent,
    PhoenixPaymentConfirmationWrapperComponent,
    PhoenixPaymentTimeoutModalComponent,
    PaymentReviewWrapperHSPhoenixComponent,
    PaymentReviewWrapperComponent,
    SimplifiedPaymentConfirmationWrapperComponent
  ],
  exports: [PaymentReviewWrapperComponent, SimplifiedPaymentConfirmationWrapperComponent],
  imports: [
    CommonModule,
    OneTimePayRoutingModule,
    UiKitModule,
    SharedServicesModule,
    FormsModule,
    ReactiveFormsModule,
    BillingSharedUiModule,
    BillingPaymentMethodFeatureModule,
    BillingOneTimePayUiModule,
    PipesModule
  ]
})
export class BillingOneTimePayFeatureModule {}
